import * as timestamp_pb from "google-protobuf/google/protobuf/timestamp_pb";

import { AUTHER_CLIENT, getRequestMetadata } from "../index";

const { GetOrganizationsRequest, UpsertOrganizationRequest, Organization } = require("../../protos/auther_pb");

const getOrganizations = (ids) => {
  const request = new GetOrganizationsRequest();
  request.getIdsList(ids);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.getOrganizations(request, getRequestMetadata(), (err, response) => {
      if (err) {
        console.warn("getOrganizations", err.code, err.message);
        reject(err);
      } else {
        const protoResponse = response?.u?.[0] ?? [];
        const organizations = protoResponse.map((organizationRes) => {
          return convertOrganizationFromProto(organizationRes);
        });

        resolve(organizations);
      }
    });
  });
};

const createOrganization = ({ name }) => {
  const request = new UpsertOrganizationRequest();
  const organization = new Organization();

  organization.setName(name);

  const ts = new timestamp_pb.Timestamp();
  ts.setSeconds(0);
  ts.setNanos(0);

  organization.setCreatedAt(ts);
  organization.setUpdatedAt(null);
  organization.setDeletedAt(null);
  organization.setDeleterId(null);

  request.setOrganization(organization);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.upsertOrganization(request, getRequestMetadata(), (err) => {
      if (err) {
        console.warn("createOrganization", err.code, err.message);
        reject(err);
      } else {
        resolve(true);
      }
    });
  });
};

const convertOrganizationFromProto = (organizationProto) => {
  return {
    id: organizationProto[0],
    name: organizationProto[1],
    createdAt: organizationProto[2],
    updatedAt: organizationProto[3],
    deletedAt: organizationProto[4],
    deleterId: organizationProto[5]
  };
};

export { convertOrganizationFromProto, createOrganization, getOrganizations };
